import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      offset={24}
      gap={12}
      expand
      visibleToasts={4}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast relative overflow-hidden pr-8 group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "!absolute !right-2 !top-2 !left-auto !rounded-md !p-1 !bg-red-600 !hover:bg-red-700 !text-white !opacity-100 !shadow-none !border-none !z-0 [&>svg]:stroke-white [&>svg]:fill-white",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
